module.exports = __webpack_public_path__ + "img/slide-services-4.93985fd9.webp";